var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('navbar',{attrs:{"expanded":true,"colored":_vm.navbar_color}}),_c('div',{staticClass:"journey"},[_c('family'),_c('origin'),_c('vision'),_c('terroir'),_c('team')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }